import type { ReactNode } from 'react';

import { TopNav } from 'components/navigation';

import 'components/layout/styles/TopNavLayout.scss';

export type TopNavLayoutProps = {
    children: ReactNode;
    className?: string;
};

export const TopNavLayout = (props: TopNavLayoutProps) => {

    const { children, className } = props;

    return (
        <div className="top-nav-layout d-flex flex-column flex-fill" style={{ minHeight: 0 }}>
            <TopNav />

            <div
                className={`top-nav-layout-content d-flex flex-column flex-fill overflow-auto${className ? ` ${className}` : ''}`}

                // The scroll region for page content; the top nav stays pinned above it.
                style={{ minHeight: 0 }}
            >
                {children}
            </div>
        </div>
    );

};